import React, {
  memo,
  CSSProperties,
  cloneElement,
  ReactElement,
  useRef,
  useLayoutEffect,
} from 'react'

export interface ICalendarBarProps {
  edges: [string, string]
  style?: CSSProperties
  className?: string
  overlapping?: boolean
  children: ReactElement
  highlight?: boolean
  isExpanded?: boolean
  /**
   * Show/hide <CalendarBar />
   * @default true
   */
  isVisible?: boolean
}

const HIGHLIGHT_CLASS = 'highlight'

export const CalendarBar = memo<ICalendarBarProps>(
  ({ children: child, className, highlight, isExpanded, isVisible = true, overlapping, style }) => {
    const ref = useRef<HTMLDivElement>(null)
    useLayoutEffect(() => {
      const { current: node } = ref
      const removeHighlight = () => {
        if (node) node.classList.remove(HIGHLIGHT_CLASS)
      }
      // If the bar's Calendar Row is collapsed, do not scroll and highlight it
      if (highlight && node && isExpanded) {
        setTimeout(() => {
          node.scrollIntoView()
          node.classList.add(HIGHLIGHT_CLASS)
          document.addEventListener('mousedown', removeHighlight)
        }, 0)
      }
      return () => {
        if (highlight) document.removeEventListener('mousedown', removeHighlight)
      }
    }, [highlight])

    return (
      <>
        {isVisible && (
          <>
            <div className='calendar-view-bar-backdrop' style={style} />
            <div className={`calendar-view-bar ${className}`} style={style} ref={ref}>
              {cloneElement(child, typeof child.type === 'string' ? undefined : { overlapping })}
            </div>
          </>
        )}
      </>
    )
  }
)
